import $ from 'jquery';
import twitterFetcher from 'twitter-fetcher';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default class HomeTwitter {
  constructor(section) {
    this.$el = $(section.el);
    this.$tweetContainer = null;
    this.$slideshow = $('[data-twitter-tweets]', this.$el);

    if (this.$el.length) {
      this.init();
    }
  }

  init() {
    this.$tweetContainer = this.$el.find('[data-twitter-tweets]');
    const username = this.$el.find('[data-twitter-username]').attr('data-twitter-username');
    const retweets = this.$el.find('[data-show-retweets]').length;

    this._fetchTweets(username, retweets);
  }

  _fetchTweets(username, retweets) {
    twitterFetcher.fetch({
      profile: {'screenName': username},
      maxTweets: 5,
      enableLinks: true,
      showUser: false,
      showTime: false,
      showRetweet: retweets,
      customCallback: (tweets) => this.renderTweets(tweets, username),
      showInteraction: false,
      useEmoji: true
    });
  }

  renderTweets(tweets, username) {
    this.$tweetContainer.html('');

    if (tweets.length) {
      for (var i = 0, len = tweets.length; i < len; i++) {
        this.$tweetContainer.append(
          `<div class="twitter-tweet-wrapper">
            <div class="twitter-tweet-content">
              <div class="twitter-tweet">
                ${tweets[i]}
              </div>

              <a class="twitter-tweet-username" href="http://twitter.com/${username}">
                @${username}
              </a>
            </div>
          </div>`
        );
      }

      this._bindEvents();
      this._initFlickity();
    } else {
      console.log('No tweets to display. Most probable cause is an incorrectly entered username.');
    }
  }

  _bindEvents() {
    $(window).on('resize', () => {
      this._setSlideHeight();
    });
  }

  _initFlickity() {
    this.flickity = new Flickity(this.$slideshow[0], {
      accessibility: true,
      adaptiveHeight: true,
      autoPlay: this.autoplay,
      imagesLoaded: true,
      pageDots: false,
      pauseAutoPlayOnHover: true,
      prevNextButtons: false,
      wrapAround: true,
      selectedAttraction: 0.01,
      friction: 0.15,
    });

    this._setSlideHeight();
  }

  _setSlideHeight() {
    const $slides = $('.twitter-tweet-wrapper', this.$el);
    let maxHeight = 0;

    $slides.each(function(){
      const thisH = $(this).outerHeight();
      if (thisH > maxHeight) {
        maxHeight = thisH;
      }
    });

    $slides.css('min-height', maxHeight);
  }
}
